import React from 'react';

const JS_2023 = () => {
  return (
    <div >
      <h1>JS_2023</h1>
      <p>Placeholder component for: "JS 2023"</p>
    </div>
  );
};

export default JS_2023;
